import { TableWidget } from "app/components/widget/widget-types/TableWidget";
import _ from "lodash";
import { TableTemplateV2 } from "../../../../components/widget/dashboard/TableTemplate-v2";

/**
 * Created by Eran.Shain on 12/6/2016.
 */

class MmxTrafficSourcesTableWidget extends TableWidget {
    getMetricColumnsConfig() {
        return super
            .getMetricColumnsConfig()
            .filter((col) => col.name !== "HasAdsense")
            .map((col) => {
                switch (col.name) {
                    case "Domain":
                        return _.merge({}, col, {
                            cellTemp: "mmx-traffic-source",
                        });
                    default:
                        return col;
                }
            });
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    protected _getExcelEndPoint() {
        return `/widgetApi/MarketingMix/TrafficSourcesOverviewData/Excel?`;
    }
}

MmxTrafficSourcesTableWidget.register();
